// 使用webpack模块导入方式，让webpack自动处理资源路径
const djz = {
    title: '店军师',
    logo: './static/img/logo.png',
    favicon: './static/favicon.ico'

}

const lianglimi = {
    title: '两粒米',
    logo: './static/img/lianglimi-logo.png',
    favicon: './static/lianglimi-favicon.ico'
}


export default lianglimi




// WEBPACK FOOTER //
// ./src/oem/oem.js